import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService, environment, MyHttpClientFactory } from '@ups/xplat/core';
import { Requisition, RequisitionItem, ShipmentDocumentItem } from '../models';

@Injectable({
  providedIn: 'root',
})
export class RequisitionService extends DataService<unknown> {
  route: string;

  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/requisition',
      httpClient,
      httpFactory
    );
  }

  getRequisition(requisitionId: string): Observable<Requisition> {
    return this.httpClient.get<Requisition>(
      `${this.route}/items/${requisitionId}`
    );
  }

  getRequisitions(facilityKeyId: number): Observable<Requisition[]> {
    return this.httpClient.get<Requisition[]>(`${this.route}/${facilityKeyId}`);
  }

  createRequisition(requisitionRequest: Requisition) {
    return this.httpClient.post<string>(`${this.route}`, requisitionRequest);
  }

  updateRequisition(requisitionRequest: Requisition) {
    return this.httpClient.put(`${this.route}`, requisitionRequest);
  }

  updateRequisitionNote(shipmentDocumentItem: ShipmentDocumentItem) {
    return this.httpClient.put(
      `${this.route}/UpdateRequisitionNote`,
      shipmentDocumentItem
    );
  }

  addItemsToRequisition(
    requisitionId: string,
    requisitionItems: RequisitionItem[]
  ) {
    return this.httpClient.put(
      `${this.route}/${requisitionId}`,
      requisitionItems
    );
  }

  removeItemsFromRequisition(requisitionItemIds: string[]) {
    return this.httpClient.request('delete', `${this.route}`, {
      body: requisitionItemIds,
    });
  }

  completeRequisition(requisitionId: string) {
    return this.httpClient.put(
      `${this.route}/completerequisition/${requisitionId}`,
      null
    );
  }
}
